'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _translate = _interopRequireDefault(require("./../translate"));

var _exportEntry = _interopRequireDefault(require("./lib/export-entry"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formInputs = require("../form-inputs");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ExportContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(ExportContainer, _React$Component);

  function ExportContainer(props) {
    var _this;

    _classCallCheck(this, ExportContainer);

    _this = _possibleConstructorReturn(this, (ExportContainer.__proto__ || Object.getPrototypeOf(ExportContainer)).call(this, props));
    _this.state = {
      confirmExport: true
    };
    return _this;
  }

  _createClass(ExportContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.role !== 'cantonresponsible') {
        this.setState({
          confirmExport: false
        });
      }
    }
    /**
     *
     * @returns {*}
     */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          t = _this$props.t,
          projects = _this$props.projects,
          role = _this$props.role;
      var entries = [{
        key: 'vomhof',
        title: t('Vomhof Registrationen csv'),
        description: t('Export Vomhof Registrations text'),
        linkTitle: t('Vomhof Registrationen csv'),
        downloadUrl: '/export/de/vomhof/csv',
        linkText: t('Export')
      }, {
        key: 'brunch',
        title: t('Brunch Registrationen csv'),
        description: t('Export Brunch Registrations text'),
        linkTitle: t('Brunch Registrationen csv'),
        downloadUrl: '/export/de/brunch/csv',
        linkText: t('Export')
      }, {
        key: 'schub',
        title: t('SchuB Registrationen csv'),
        description: t('Export SchuB Registrations text'),
        linkTitle: t('SchuB Registrationen csv'),
        downloadUrl: '/export/de/schub/csv',
        linkText: t('Export')
      }, {
        key: 'stallvisite',
        title: t('Stallvisite Registrationen csv'),
        description: t('Export Stallvisite Registrations text'),
        linkTitle: t('Stallvisite Registrationen csv'),
        downloadUrl: '/export/de/stallvisite/csv',
        linkText: t('Export')
      }, {
        key: 'lockpfosten',
        title: t('Lockpfosten Registrationen csv'),
        description: t('Export Lockpfosten Registrations text'),
        linkTitle: t('Lockpfosten Registrationen csv'),
        downloadUrl: '/export/de/lockpfosten/csv',
        linkText: t('Export')
      }, {
        key: 'toh',
        title: t('Toh Registrationen csv'),
        description: t('Export Toh Registrations text'),
        linkTitle: t('Toh Registrationen csv'),
        downloadUrl: '/export/de/toh/csv',
        linkText: t('Export')
      }, {
        key: 'lgw',
        title: t('Lgw Registrationen csv'),
        description: t('Export Lgw Registrations text'),
        linkTitle: t('Lgw Registrationen csv'),
        downloadUrl: '/export/de/lgw/csv',
        linkText: t('Export')
      }];
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "comp-homepage"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell"
      }, /*#__PURE__*/_react.default.createElement("h1", null, t('Exports')), this.props.role === 'cantonresponsible' && /*#__PURE__*/_react.default.createElement(_formInputs.CheckboxInput, {
        name: 'confirm-export',
        label: t('canton responsible data check'),
        value: !this.state.confirmExport,
        id: 'confirm-export-checkbox',
        onChange: function onChange() {
          return _this2.setState({
            confirmExport: !_this2.state.confirmExport
          });
        }
      }), entries.reduce(function (prev, curr) {
        if (projects.indexOf(curr.key) >= 0 || role === 'admin') {
          prev.push(curr);
        }

        return prev;
      }, []).map(function (entry, key) {
        return /*#__PURE__*/_react.default.createElement(_exportEntry.default, {
          key: key,
          title: entry.title,
          linkText: entry.linkText,
          downloadUrl: entry.downloadUrl,
          description: entry.description,
          confirmExport: _this2.state.confirmExport,
          linkTitle: entry.linkTitle
        });
      })));
    }
  }]);

  return ExportContainer;
}(_react.default.Component);

ExportContainer.propTypes = {
  t: _propTypes.default.func,
  projects: _propTypes.default.arrayOf(_propTypes.default.string),
  role: _propTypes.default.string
};

var _default = (0, _translate.default)(ExportContainer);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/export-container/index.js
// module id = 757
// module chunks = 0